import { h } from 'preact';
import styled from 'styled-components';
import { FireIcon } from '../icons/Fire';
import { useUser } from '@authentic/loyalty-pwa/providers';
import { TIERS } from '../constants/Tiers';

export const breakpoints = {
  sm: '600px',
  md: '960px',
  lg: '1280px',
};

const WidgetWrapper = styled.div<{ color: string }>`
  background-color: ${(props) => (props.color ? props.color : 'white')};
  display: flex;
  align-content: center;
  height: 50px;
  position: absolute;
  justify-content: center;
  border-radius: 0 0 7px 7px;
  margin-left: 140px;
  
  @media print {
      display: none;
  }

  @media screen and (max-width: ${breakpoints.md}) {
    position: fixed;
    border-radius: 0 0 0 0;
    z-index: 1000;
    width: 100%;
    margin-left: 0;
    justify-content: space-between;
  }
`;

const PointsLabel = styled.label`
  font-family: Nunito Sans;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 22px;
  text-align: right;
  letter-spacing: 0.02em;
  color: white;
  padding-left: 5px;

  @media screen and (max-width: ${breakpoints.md}) {
    margin-left: 7px;
  }
`;

const NameLabel = styled.div`
  font-family: Nunito Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
  letter-spacing: 0.02em;
  color: #ffffff;
  margin-top: 15px;
  padding-left: 24px;
  padding-right: 8px;
  @media screen and (max-width: ${breakpoints.md}) {
    margin-left: 29px;
  }
`;

const TierDiv = styled.div`
  display: inline-flex;
  margin-top: 15px;
  padding-right: 15px;
  padding-left: 10px;

  @media screen and (max-width: ${breakpoints.md}) {
    display: inline-flex;
    margin-right: 30px;
    margin-bottom: 7px;
    justify-content: space-between;
  }
`;

export const UserWidget = () => {
  const user = useUser();

  if (!user || !user.summary)
    return null

  const userTier = user.summary.tier.toLowerCase()
  const tier = TIERS.filter((tier) => tier.id == userTier).pop();

  return (
    <WidgetWrapper color={tier ? tier.color : '#000'}>
      <NameLabel>Hey {user.summary.first_name}!</NameLabel>
      <TierDiv>
        <FireIcon width={19} height={22.73} color={'white'} />
        <PointsLabel>{user.summary.points} PTS</PointsLabel>
      </TierDiv>
    </WidgetWrapper>
  );
};
